// extracted by mini-css-extract-plugin
export default {"cell":"TableCell-module__cell__t0gmj","head":"TableCell-module__head__WkpHr","higher":"TableCell-module__higher__22d9r"};